// extracted by mini-css-extract-plugin
module.exports = {"accesory-card-list":"styles_accesory-card-list__IPh5D","accesory-card-list__item":"styles_accesory-card-list__item__zxufN"};